WiseMetering.Collection.SiteTags = WiseMetering.Collection.extend({
    hasOrganization: true,
    model: WiseMetering.Model.SiteTag,
    url: '/site_tags'
});
